import { CSSInterpolation } from '@emotion/css/create-instance'

import { CssVars } from '../../themes'

export function getInputContainerBorderStyles(
  border: number,
  state: 'disabled' | 'error' | 'default' | undefined = 'default'
): CSSInterpolation {
  let additionalStyles: CSSInterpolation = {}

  // The border color differs based on `state`, hover, and focus.
  if (state === 'disabled') {
    additionalStyles = {
      borderColor: 'transparent',
    }
  } else if (state === 'error') {
    additionalStyles = {
      borderColor: CssVars.semantic.error.base,
    }
  } else if (state === 'default') {
    additionalStyles = {
      '&:focus-within': {
        borderColor: CssVars.semantic.primary.base,
      },
      '&:hover:not(:focus-within)': {
        borderColor: CssVars.neutral.fg3,
      },
      borderColor: CssVars.neutral.bg3,
    }
  }
  return {
    backgroundColor:
      state === 'disabled' ? CssVars.neutral.bg2 : CssVars.neutral.bg1,
    borderRadius: CssVars.size.borderRadius,
    borderStyle: 'solid',
    borderWidth: border,
    boxSizing: 'border-box',
    transition: 'border-color 200ms ease',
    ...additionalStyles,
  }
}

export function getInputStyles(
  state: 'disabled' | 'error' | 'default' | undefined = 'default'
): CSSInterpolation {
  // The placeholder should be FG3 if disabled or focused, and FG2 otherwise.
  const additionalStyles: CSSInterpolation =
    state === 'disabled'
      ? {
          '&::placeholder': {
            color: CssVars.neutral.fg3,
          },
          color: CssVars.neutral.fg2,
        }
      : {
          '&::placeholder': {
            color: CssVars.neutral.fg2,
          },
          '&:focus::placeholder': {
            color: CssVars.neutral.fg3,
          },
        }

  return {
    background: 'transparent',
    border: 'none',
    flex: 1,
    outline: 'none',
    ...additionalStyles,
  }
}
